module.exports = __webpack_public_path__ + "img/banner.9875ec98.jpg";